module.exports = __webpack_public_path__ + "static/media/funnel_description_mobile_en.bee3226e.png";